import { useState, useEffect } from 'react';
import AccessPolicyService from '../services/accessPolicyService';
import store from '../store';
import isEqual from 'lodash.isequal';
import { usePartialState } from './usePartialState';
const useAccessPolicy = (policy) => {
    const [hasAccess, setHasAccess] = useState(undefined);
    const { currentUser } = usePartialState(store.auth, ['currentUser.accessDetails'], isEqual);
    useEffect(() => {
        setHasAccess(AccessPolicyService.hasAccess(policy));
    }, [policy, currentUser.accessDetails]);
    return hasAccess;
};
export default useAccessPolicy;
